import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PostHogProvider } from "posthog-js/react";

// Simple initialization for the showcase site
// PostHog is optional - only initializes if API key is provided

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

// Only wrap with PostHogProvider if we have a valid API key
const AppWithProviders = posthogKey ? (
  <PostHogProvider
    apiKey={posthogKey}
    options={{
      api_host: posthogHost,
      defaults: "2025-05-24",
      capture_exceptions: true,
      opt_in_site_apps: true,
      debug: process.env.NODE_ENV === "development",
    }}
  >
    <App />
  </PostHogProvider>
) : (
  <App />
);

root.render(<React.StrictMode>{AppWithProviders}</React.StrictMode>);
